module.exports = __webpack_public_path__ + "img/selected5-min.290b7af2.png";